module.exports = __webpack_public_path__ + "static/media/love-struck.f5750980.png";